import React, { useCallback, useState } from 'react'
import { TutorialStyles } from './Style'
import { tutorialsHooks } from '.'
import { TutorialRoutes } from 'router'
import { Button } from 'components/Form'
import { Link, useLocation, useNavigate } from 'react-router-dom'

const Tutorials = () => {
    const [selectedBarIndex, setSelectedBarIndex] = useState(0)
    const menuBarItems = tutorialsHooks.useMenuBarItems()
    const navigate = useNavigate()
    const location = useLocation();

    const selectTutorials = useCallback((index) => {
        setSelectedBarIndex(index)
        navigate(menuBarItems[index].to)
    }, [])

    return (
        <TutorialStyles>
            <div className='side-bar'>
                <div className='side-bar-title'>
                    מה תרצו ללמד?
                </div>
                <div className='side-bar-items'>
                    {menuBarItems.map((item, index) => {
                        const { label } = item
                        // const isSelectedItem = selectedBarIndex === index
                        const isSelectedItem = location.pathname === item.to

                        return (
                            <div className='side-bar-item'>
                                <Link to={{ pathname: item.to }}>
                                    <Button
                                        action={() => selectTutorials(index)}
                                        lightColor="lightSecondary"
                                        variant={isSelectedItem ? "light" : "text"}
                                        color={isSelectedItem ? "secondary" : "dark"}
                                        size="small"
                                        systemUI={false}
                                        label={label}
                                    />
                                </Link>
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className='tutorial-content'>
                <TutorialRoutes />
            </div>
        </TutorialStyles>
    )
}

export default Tutorials